/* global sessionStorage */

export function setItem(key, value) {
  try {
    const jsonText = JSON.stringify(value);
    sessionStorage.setItem(key, jsonText);
  } catch (error) {
    console.error(`Error adding ${key} to sessionStorage`, error);
  }
}

export function getItem(key) {
  const jsonText = sessionStorage.getItem(key);

  if (!jsonText) {
    return null;
  }

  try {
    return JSON.parse(jsonText);
  } catch (error) {
    console.error(`Error getting ${key} from sessionStorage`, error);
    return null;
  }
}
